// 上传前预解码校验：已损坏的图片在调用上传接口前拦截。
export const ensureDecodableImage = async (file: File): Promise<boolean> => {
  // 非图片文件不做解码校验
  if (!file.type.startsWith('image/')) {
    return true;
  }

  // createImageBitmap 不支持无尺寸的 SVG，跳过校验
  if (file.type === 'image/svg+xml') {
    return true;
  }

  // 旧 Safari（<15）及 IE 无 createImageBitmap，降级为跳过预校验
  if (typeof createImageBitmap !== 'function') {
    return true;
  }

  let bitmap: ImageBitmap | null = null;

  try {
    // 只做解码校验，缩到小尺寸以降低大图的内存/CPU 开销
    bitmap = await createImageBitmap(file, {
      resizeWidth: 256,
      resizeHeight: 256,
      resizeQuality: 'low',
    });

    return true;
  }
  catch {
    return false;
  }
  finally {
    bitmap?.close();
  }
};
